import { apiClient } from "@/api/modules/base.ts";
import {
    GetDocumentFileRoute,
    Route
} from "@/api/modules/autoQ/documents/routes.ts";
import type {
    PredefinedDocument
} from "@/api/modules/autoQ/documents/types.ts";
import type { AxiosPromise } from "axios";

export const getPredefinedDocuments = (): AxiosPromise<PredefinedDocument[]> => apiClient.get(Route.GetPredefinedDocuments);

export const getDocumentFile = (assetId: number): AxiosPromise<Blob> =>
    apiClient.get(GetDocumentFileRoute(assetId), { responseType: "blob" });